var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultProfileImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2399 25.56C24.0999 25.54 23.9199 25.54 23.7599 25.56C20.2399 25.44 17.4399 22.56 17.4399 19.02C17.4399 15.4 20.3599 12.46 23.9999 12.46C27.6199 12.46 30.5599 15.4 30.5599 19.02C30.5399 22.56 27.7599 25.44 24.2399 25.56Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.48 38.76C33.92 42.02 29.2 44 24 44C18.8 44 14.08 42.02 10.52 38.76C10.72 36.88 11.92 35.04 14.06 33.6C19.54 29.96 28.5 29.96 33.94 33.6C36.08 35.04 37.28 36.88 37.48 38.76Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProfileImage);
export default __webpack_public_path__ + "static/media/default-profile-image.5abc94a75b34652ff6ee4d01151f2525.svg";
export { ForwardRef as ReactComponent };